import getConfig from 'next/config';

const {
	publicRuntimeConfig: { RECAPTCHA_SITE_KEY },
} = getConfig();

let scriptLoadPromise = null;

const loadRecaptcha = () => {
	if (typeof window === 'undefined' || !RECAPTCHA_SITE_KEY) {
		return Promise.resolve(false);
	}

	if (window.grecaptcha) {
		return Promise.resolve(true);
	}

	if (!scriptLoadPromise) {
		scriptLoadPromise = new Promise((resolve) => {
			const script = document.createElement('script');
			script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
			script.async = true;
			script.onload = () => resolve(true);
			script.onerror = () => resolve(false);
			document.head.appendChild(script);
		});
	}

	return scriptLoadPromise;
};

// Returns a fresh, single-use v3 token for the given action, or '' if
// reCAPTCHA isn't configured (RECAPTCHA_SITE_KEY unset) or fails to load -
// the backend (see api/models/Recaptcha.php) treats an empty/missing token
// the same way: a no-op unless it has its own secret key configured, so
// this fails open rather than blocking sign-in over a script-loading
// hiccup.
export const getRecaptchaToken = async (action = 'login') => {
	if (!RECAPTCHA_SITE_KEY) {
		return '';
	}

	try {
		const loaded = await loadRecaptcha();
		if (!loaded || !window.grecaptcha) {
			return '';
		}

		return await new Promise((resolve) => {
			window.grecaptcha.ready(() => {
				window.grecaptcha
					.execute(RECAPTCHA_SITE_KEY, { action })
					.then(resolve)
					.catch(() => resolve(''));
			});
		});
	} catch (error) {
		return '';
	}
};
